import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";
import {
    FCA_BANK_10, FCA_BANK_30, FCA_BANK_32, FCA_BANK_35, FCA_BANK_5, FCA_BANK_50
} from "./Constants";


export const useFCABankValues = () => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'blackList'});
    const theme = useTheme();

    const getFCABankLabel = (status: any ) => {
        switch (status) {
            case FCA_BANK_5  : return t('fcaBankValues.fcaCode_5');
            case FCA_BANK_10 : return t('fcaBankValues.fcaCode_10');
            case FCA_BANK_30 : return t('fcaBankValues.fcaCode_30');
            case FCA_BANK_32 : return t('fcaBankValues.fcaCode_32');
            case FCA_BANK_35 : return t('fcaBankValues.fcaCode_35');
            case FCA_BANK_50 : return t('fcaBankValues.fcaCode_50');

            default : return ''
        }
    };

    return {
        getFCABankLabel
    }
}